import { Category } from '../Models/Order';

export const getParentId = (categoriesList: Category[] | undefined, childId: number | string | undefined) => {
  const children = categoriesList?.find((category) => category.id === childId);
  const valueCascader = [children?.parentId, childId];

  return valueCascader;
};
